import type { MiddlewareFunction } from "@segment/analytics-next";
import { effectiveReferrer } from "./effectiveReferrer";

/**
 * Segment source middleware that undoes the referrer a Cloudflare challenge
 * overwrote. Applied to every outgoing event, because Segment attaches
 * `context.page.referrer` to all of them rather than only to pageviews.
 *
 * Instrumentation on production confirmed this restores referrers the browser
 * had lost, and recorded which sources they came from:
 * https://app.shortcut.com/grailed-team/story/129165/temporarily-instrument-cloudflare-challenge-referrer-restorations#activity-129483
 */
export const restoreReferrer: MiddlewareFunction = ({ payload, next }) => {
  const page = payload.obj.context?.page;

  if (page) {
    page.referrer = effectiveReferrer({
      documentReferrer: page.referrer ?? "",
      serverReferrer: window.serverReferrer,
    });
  }

  next(payload);
};
